// get Parameter
let params = {};

if (window.location.search) {
  let parts = window.location.search.substring(1).split('&');

  for (var i = 0; i < parts.length; i++) {
    let nv = parts[i].split('=');
    if (!nv[0]) continue;
    params[nv[0]] = nv[1] || true;
  }
}

if (params.roicn) {
  let companyName = params.roicn;
  let tickets = params.qr;
  let agents = params.ag;
  let shifting = params.ss;
  let industryType = params.it;

  let val = (tickets / agents);
  let increaseValue,
    decreaseValue,
    resolveHrs,
    fdTicketsPerMonth,
    ticketsDefPerYear,
    moneyPerMonth,
    perTicketCost,
    agentSalary,
    moneyAnnual,
    annual,
    hourCreation,
    hourResolution,
    hourResolutionPer,
    hourResolutionPerP2,
    hourResolutionPerP3,
    hourCreationP1,
    hourResolutionP2,
    hourResolutionP3,
    moneyPerMonthRs,
    moneyPerMonthTm,
    moneyPerMonthTs,
    totalHoursSaved,
    totalMoneySaved,
    forForestPlan,
    roi;

  fdTicketsPerMonth = 0.9;
  annual = 12;

// Calculation Percentage
  if (shifting === 'os') {
    jQuery('.ot-tickets .roi-title, .ot-hrs .roi-title').text('With Other Helpdesk');
    jQuery('.ot-tickets .roi-title-icon img, .ot-hrs .roi-title-icon img').attr('src', '/static-assets/images/freshdesk/roi/other-helpdesks.svg');
    jQuery('.roi-title-vs').text('Other Helpdesk vs. Freshdesk');

    switch (true) {
      case (val <= 50):
        increaseValue = 1.1;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 100):
        increaseValue = 1.12;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 200):
        increaseValue = 1.5;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 350):
        increaseValue = 1.17;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 500):
        increaseValue = 1.20;
        decreaseValue = increaseValue - 1;
        break;
      case (val > 500):
        increaseValue = 1.3;
        decreaseValue = increaseValue - 1;
        break;
    }
  } else {
    jQuery('.ot-tickets .roi-title, .ot-hrs .roi-title').text('With Email');
    jQuery('.tool-tip-button').css('display', 'none');
    jQuery('.roi-title-vs').text('Email vs. Freshdesk');
    switch (true) {
      case (val <= 50):
        increaseValue = 1.18;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 100):
        increaseValue = 1.20;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 200):
        increaseValue = 1.23;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 350):
        increaseValue = 1.27;
        decreaseValue = increaseValue - 1;
        break;
      case (val <= 500):
        increaseValue = 1.3;
        decreaseValue = increaseValue - 1;
        break;
      case (val > 500):
        increaseValue = 1.4;
        decreaseValue = increaseValue - 1;
        break;
    }
  }

  resolveHrs = increaseValue * industryType;

  jQuery('.roi-company span').text(decodeURIComponent(companyName));

  const chartDataTicketsPerMonth = function ($data) {
    jQuery('.ot-tickets .roi-tickets').text(Math.round($data));
    jQuery('.ot-tickets .chart-block').animate({height: '200px'}, 3000);
    jQuery('.fd-tickets .roi-tickets').text(Math.round($data * fdTicketsPerMonth));
    jQuery('.fd-tickets .chart-block').animate({height: (200 * 90 / 100)}, 3000);
  };

  const avgTimeResolveTicket = function ($data) {
    jQuery('.ot-hrs .roi-tickets').text($data + ' hrs');
    jQuery('.ot-hrs .chart-block').animate({height: '200px'}, 3000);
    jQuery('.fd-hrs .roi-tickets').text(industryType + ' hrs');
    jQuery('.fd-hrs .chart-block').animate({height: (200 * (industryType / $data * 100) / 100)}, 3000);
  };

  chartDataTicketsPerMonth(tickets);
  avgTimeResolveTicket(Math.round(resolveHrs));

  // Tickets deflected per year
  ticketsDefPerYear = (tickets - (tickets * fdTicketsPerMonth)) * annual;

  jQuery('.ticket-deflected-p1').text(Math.round(ticketsDefPerYear).toLocaleString());

  // Agents Salary per annum (approx.)
  agentSalary = 55000 / annual;

  // Per Ticket COST
  perTicketCost = (agents * agentSalary) / tickets;

  // Man Hours SAVINGS
  hourCreation = 22 * 8 * 0.1;
  hourResolution = 22 * 8 * decreaseValue;

  hourCreationP1 = hourCreation * annual;
  hourResolutionP2 = ((hourResolution * annual) / 20) * 13;
  hourResolutionP3 = ((hourResolution * annual) / 20) * 7;

  jQuery('.roi-time-saved-p1').text(Math.round(hourCreationP1).toLocaleString() + ' hrs');
  jQuery('.roi-time-saved-p2').text(Math.round(hourResolutionP2).toLocaleString() + ' hrs');
  jQuery('.roi-time-saved-p3').text(Math.round(hourResolutionP3).toLocaleString() + ' hrs');

  // Man HOurs savings Percentage
  hourResolutionPer = decreaseValue * 100;
  hourResolutionPerP2 = (hourResolutionPer / 20) * 13;
  hourResolutionPerP3 = (hourResolutionPer / 20) * 7;

  jQuery('.roi-hours-per-p2').text(Math.round(hourResolutionPerP2).toLocaleString() + '%');
  jQuery('.roi-hours-per-p3').text(Math.round(hourResolutionPerP3).toLocaleString() + '%');

  // Ticket Deflection - Money saved per year
  moneyPerMonth = tickets * 0.1 * perTicketCost;
  moneyAnnual = moneyPerMonth * annual;

  jQuery('.roi-money-saved-p1').text('$ ' + Math.round(moneyAnnual).toLocaleString());

  // Ticket Management & Resolution - Money saved per year
  moneyPerMonthRs = (agents * agentSalary) * decreaseValue;

  moneyPerMonthTm = ((moneyPerMonthRs * annual) / 20) * 13;
  moneyPerMonthTs = ((moneyPerMonthRs * annual) / 20) * 7;

  jQuery('.roi-money-saved-p2').text('$ ' + Math.round(moneyPerMonthTm).toLocaleString());
  jQuery('.roi-money-saved-p3').text('$ ' + Math.round(moneyPerMonthTs).toLocaleString());

  // Total Money & Time saved per year
  totalHoursSaved = hourCreationP1 + hourResolutionP2 + hourResolutionP3;
  totalMoneySaved = moneyAnnual + moneyPerMonthTm + moneyPerMonthTs;

  jQuery('.roi-hours-saved-total').text(Math.round(totalHoursSaved).toLocaleString() + ' hrs');
  jQuery('.roi-money-saved-total').text('$ ' + Math.round(totalMoneySaved).toLocaleString());

  // Investment in Freshdesk - For x agents at forestplan
  forForestPlan = agents * 82 * annual;
  roi = totalMoneySaved / forForestPlan;

  jQuery('.roix').text(Math.round(roi).toLocaleString() + 'x');

  let shareLink = window.location.href;
  let shareSubject = 'Detailed ROI Report for ' + companyName;
  let mailTo = 'mailto:?subject=' + shareSubject + '&body=' + encodeURIComponent(shareLink);

  jQuery('.share-link, #share-link').attr('href', mailTo);
  jQuery('.report-url').val('https://www.freshworks.com/freshdesk/roi-detailed-report' + window.location.search);
}
